// src/Redux/reducers/userReducers.js
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  USER_FORGOT_REQUEST,
  USER_FORGOT_SUCCESS,
  USER_FORGOT_FAIL,
  USER_RESET_REQUEST,
  USER_RESET_SUCCESS,
  USER_RESET_FAIL,
} from "../constants/userConstants.js";

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const initialState = { userInfo: userInfoFromStorage };

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
    case USER_REGISTER_REQUEST:
      return { ...state, loading: true };

    case USER_LOGIN_SUCCESS:
    case USER_REGISTER_SUCCESS:
      return { loading: false, userInfo: action.payload };

    case USER_LOGIN_FAIL:
    case USER_REGISTER_FAIL:
      return { loading: false, error: action.payload };

    case USER_LOGOUT:
      return { userInfo: null };

    // forgot/reset flows can store messages in state if needed
    case USER_FORGOT_REQUEST:
      return { ...state, forgotLoading: true };
    case USER_FORGOT_SUCCESS:
      return { ...state, forgotLoading: false, forgotMsg: action.payload?.msg || "Sent" };
    case USER_FORGOT_FAIL:
      return { ...state, forgotLoading: false, forgotError: action.payload };

    case USER_RESET_REQUEST:
      return { ...state, resetLoading: true };
    case USER_RESET_SUCCESS:
      return { ...state, resetLoading: false, resetMsg: action.payload?.msg || "Password updated" };
    case USER_RESET_FAIL:
      return { ...state, resetLoading: false, resetError: action.payload };

    default:
      return state;
  }
};
